module.exports = __webpack_public_path__ + "img/向下调节.c547a846.png";